module.exports = __webpack_public_path__ + "img/16 estudiar.8f056a6a.jpg";